import { render, staticRenderFns } from "./flyout_menu.vue?vue&type=template&id=28c1a3bf&scoped=true"
import script from "./flyout_menu.vue?vue&type=script&lang=js"
export * from "./flyout_menu.vue?vue&type=script&lang=js"
import style0 from "./flyout_menu.vue?vue&type=style&index=0&id=28c1a3bf&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "28c1a3bf",
  null
  
)

export default component.exports